__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "whitelabel";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@invent/http-client", "1.9.3", () => (() => (__webpack_require__(971))), 1);
			register("@invent/json-settings", "1.18.8", () => (() => (__webpack_require__(28619))), 1);
			register("@invent/platform-api", "1.10.0", () => (() => (__webpack_require__(46589))), 1);
			register("@invent/wl-ui-kit", "3.133.12", () => (() => (__webpack_require__(40772))), 1);
			register("@invent/wlabel-shared-components", "1.14.0", () => (() => (__webpack_require__(27191))), 1);
			register("date-fns", "2.30.0", () => (() => (__webpack_require__(1274))), 1);
			register("effector-react", "22.5.4", () => (() => (__webpack_require__(93721))), 1);
			register("effector", "22.8.8", () => (() => (__webpack_require__(32489))), 1);
			register("ramda", "0.27.2", () => (() => (__webpack_require__(12550))), 1);
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(40961))), 1);
			register("react-query", "3.39.3", () => (() => (__webpack_require__(75942))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(54625))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(56347))), 1);
			register("react-use", "15.3.8", () => (() => (__webpack_require__(9583))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(96540))), 1);
			register("styled-components", "5.3.11", () => (() => (__webpack_require__(79056))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};